import useMemoizedFn from "ahooks/es/useMemoizedFn";
import { atom, useAtom } from "jotai";

export type useInventoryTypeFormResult = {
  isOpen: boolean;
  openDialog(): void;
  closeDialog(): void;
};

const isOpenAtom = atom<boolean>(false);

export function useInventoryTypeForm(): useInventoryTypeFormResult {
  const [isOpen, setIsOpen] = useAtom(isOpenAtom);

  const openDialog = useMemoizedFn(() => {
    setIsOpen(true);
  });

  const closeDialog = useMemoizedFn(() => {
    setIsOpen(false);
  });

  return {
    isOpen,
    openDialog,
    closeDialog,
  };
}
